import { FC } from 'react';

import { Group, Stack, Text, Tooltip } from '@mantine/core';

import { Project, ProjectTeaser } from 'models';

import { Avatar } from 'components/avatar/Avatar';
import { ProjectMetaItem } from 'components/project-overview/components/ProjectList';
import { useProjectMeta } from 'components/project-overview/hooks';

export const ProjectTeaserUpdated: FC<{
    project: Project | ProjectTeaser;
}> = ({ project }) => {
    const { updatedBy, updatedById, updatedWhen, updatedAt } = useProjectMeta(project);

    if (!updatedBy && !updatedWhen) {
        return null;
    }

    return (
        <Stack gap={4} justify="center">
            <ProjectMetaItem
                label={
                    <Group gap={3} wrap="wrap">
                        <Group gap={6} wrap="nowrap">
                            {updatedById && <Avatar user={updatedById} size={16} />}
                            {updatedBy ?? 'Unknown'},
                        </Group>
                        <Tooltip label={updatedAt} withArrow>
                            <Text fz="sm" c="gray.6">
                                {updatedWhen}
                            </Text>
                        </Tooltip>
                    </Group>
                }
                c="gray.6"
            />
        </Stack>
    );
};
